// LIBRARIES
import styled from "styled-components";

// MISC
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "../../constants/variables";

export const SectionWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${SIZE.max160} 0;
  max-width: 95%;
`;

export const ItemWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: row;
  height: auto;
  position: relative;
`;

export const LeftSideContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  height: 100%;
  z-index: 2;
  background-color: ${COLORS.RaisinBlack};
  padding: ${MARGIN.max110} ${MARGIN.max60};
  border-top-left-radius: ${BORDER_RADIUS.radius48};
  border-bottom-left-radius: ${BORDER_RADIUS.radius48};
`;

export const MiddleSideContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 130%;
  @media (max-width: ${DEVICE_TYPE.fullHd}) {
    height: 120%;
  }
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    height: 100%;
    bottom: -8%;
    left: -3%;
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    height: 80%;
    bottom: -8%;
    left: -3%;
  }
  position: absolute;
  width: 100%;
  left: -2%;
  bottom: -12%;
`;

export const RightSideWrapper = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  height: 100%;
  z-index: 2;
  background-color: ${COLORS.Cultured};
  padding: ${MARGIN.max110} ${MARGIN.max60};
  border-top-right-radius: ${BORDER_RADIUS.radius48};
  border-bottom-right-radius: ${BORDER_RADIUS.radius48};
`;

export const MainIllustration = styled.img`
  width: auto;
  height: 100%;
  z-index: 4;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  z-index: 2;
  gap: 20px;
  max-width: 50%;
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    max-width: 50%;
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    max-width: 45%;
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  z-index: 2;
  gap: 20px;
  max-width: 50%;
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    max-width: 50%;
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    max-width: 45%;
  }
`;
export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    justify-content: center;
    align-items: center;
  }
  gap: ${SIZE.max16};
  height: ${SIZE.max55};
  width: 100%;
  svg {
    height: ${SIZE.max40};
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max4};
  flex-wrap: wrap;
`;

export const QrRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  max-width: 80%;
`;

export const QrContainer = styled.img`
  width: ${SIZE.max120};
  height: ${SIZE.max120};
  border-radius: ${BORDER_RADIUS.radius16};
  padding: ${MARGIN.max10};
  background-color: ${COLORS.Cultured};
`;

export const ButtonContainer = styled.div`
  z-index: 10 !important;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const MobileSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: ${SIZE.max120} ${MARGIN.fix32};
  gap: ${SIZE.max100};
`;

export const MobileItemWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const MobilePhonesIllustration = styled.img`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 5;
  width: ${SIZE.max500};
  min-width: 300px;
  max-width: 85%;
  height: auto;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    min-width: 200px;
    max-width: 90%;
  }
  @media (max-width: ${DEVICE_TYPE.smallDevice}) {
    min-width: none;
    max-width: none;
    width: 100%;
  }
  height: auto;
`;

export const ContentContainer = styled.div`
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.RaisinBlack};
  padding: 70% ${MARGIN.max40} ${MARGIN.max40} ${MARGIN.max40};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: ${SIZE.max40};
  z-index: 2;
  text-align: center;
  width: ${SIZE.max750};
  min-width: 450px;
  max-width: 90%;
  height: auto;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    min-width: 350px;
    max-width: 95%;
  }
  @media (max-width: ${DEVICE_TYPE.smallDevice}) {
    min-width: none;
    max-width: none;
    width: 100%;
  }
  margin-top: -60%;
`;
export const WhiteContentContainer = styled.div`
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  padding: 70% ${MARGIN.max40} ${MARGIN.max40} ${MARGIN.max40};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: ${SIZE.max40};
  z-index: 2;
  text-align: center;
  width: ${SIZE.max750};
  min-width: 450px;
  max-width: 90%;
  height: auto;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    min-width: 350px;
    max-width: 95%;
  }
  @media (max-width: ${DEVICE_TYPE.smallDevice}) {
    min-width: none;
    max-width: none;
    width: 100%;
  }
  margin-top: -60%;
`;

export const MobileTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const MobileBody = styled.div``;
export const MobileButtonContainer = styled.div`
  border-radius: ${BORDER_RADIUS.radius21};
  margin-top: ${MARGIN.fix16};
`;
